// extracted by mini-css-extract-plugin
var _1 = "_stockOut-module__title";
export { _1 as "title" }
